import axios from 'axios';

const BASE_URL = 'https://ok2fnf6igi.execute-api.us-east-1.amazonaws.com';

export const post = async (url, data, token, requestType) => {
  try {
    return await axios.post(`${BASE_URL}${url}`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'request-type': requestType,
      },
    });
  } catch (error) {
    throw error;
  }
};

export const get = async (url, token) => {
  try {
    return await axios.get(`${BASE_URL}${url}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    throw error;
  }
};

export const del = async (url, token, data) => {
  try {
    return await axios.delete(`${BASE_URL}${url}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data,
    });
  } catch (error) {
    throw error;
  }
};

export const uploadAudioFileToS3 = async (presignedUrl, file) => {
  try {
    const fileBlob =
      file instanceof Blob ? file : new Blob([file], { type: file.type });

    const response = await axios.put(presignedUrl, fileBlob, {
      headers: {
        'Content-Type': 'audio/wav',
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const getUploadsListApi = async (url, token) => {
  try {
    return await axios.get(`${BASE_URL}${url}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    throw error;
  }
};
